import NumberFormat from 'react-number-format';
import styled, { css } from 'styled-components';

import Button from '../base/Button';
import Skeleton from '../base/Skeleton';
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';

const StyledFooter = styled.div<{ fill?: boolean }>`
  ${({ theme, fill }) => css`
    ${fill &&
    css`
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
    `}
    display: flex;
    padding: ${theme.spacing(fill ? 3 : 2)} ${theme.spacing(fill ? 6 : 3)};
    border-top: ${theme.border};
    background-color: ${theme.colors.surface.base.surface};
  `}
`;

interface TableFooterProps {
  fill?: boolean;
  current_count?: number;
  total_count?: number | null;
  loading?: boolean;
  pagination?: {
    current_page: number;
    page_size: number;
    entity_name: string;
  };
  onPreviousPage?(): void;
  onNextPage?(): void;
}

const TableFooter: React.FC<TableFooterProps> = ({
  fill,
  current_count,
  total_count,
  loading,
  pagination,
  onPreviousPage,
  onNextPage,
}) => {
  return (
    <StyledFooter fill={fill}>
      <Div flex={{ grow: true, justify: 'space-between' }}>
        <Div flex={{ align: 'center', grow: true }}>
          {total_count === null ? (
            <Skeleton w={{ px: 200 }} h={{ px: 20 }} xsmall />
          ) : (
            <Text as="span" muted shimmering={loading}>
              {pagination?.current_page && pagination?.page_size && (
                <>
                  Page {pagination.current_page} · {loading ? 'Loaded ' : 'Viewing '}
                  <Text bold as="span">
                    <NumberFormat
                      renderText={(v) => v}
                      displayType={'text'}
                      value={current_count ?? pagination.page_size}
                      thousandSeparator={','}
                    />
                  </Text>{' '}
                  {pagination.entity_name || 'results'}
                  {loading ? '...' : ''}
                </>
              )}
            </Text>
          )}
        </Div>
        <Div flex={{ align: 'center', gap: 2 }}>
          <Button
            icon="chevron_left"
            outline
            disabled={!onPreviousPage || loading}
            onClick={onPreviousPage ? onPreviousPage : undefined}
          />
          <Button
            icon="chevron_right"
            outline
            disabled={!onNextPage || loading}
            onClick={onNextPage ? onNextPage : undefined}
          />
        </Div>
      </Div>
    </StyledFooter>
  );
};

export default TableFooter;
